"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/EmbedCodeLinkStyle");
var widgets_1 = require("@tableau/widgets");
var ClipboardUtils_1 = require("../utils/ClipboardUtils");
var CopyEmbedCodeIcon_1 = require("../img/CopyEmbedCodeIcon");
var Localize_1 = require("../../gen-src/Localize");
var TelemetryService_1 = require("../utils/TelemetryService");
var EmbedCodeLinkTestId = 'copy-embed-code';
exports.EmbedCodeLinkTestId = EmbedCodeLinkTestId;
var EmbedCodeLink = /** @class */ (function (_super) {
    __extends(EmbedCodeLink, _super);
    function EmbedCodeLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            TelemetryService_1.TelemetryService.Instance.log(TelemetryService_1.ShareDialogUserActionOptions.CopyEmbedCode);
            var text = _this.props.embedCode || '';
            var successMessage = Localize_1.Messages.embedCodeCopiedNotificationText({ CONTENT_NAME: _this.props.contentName });
            ClipboardUtils_1.ClipboardUtils.copyTextToClipboard(text, successMessage);
        };
        _this.renderEmbedCode = function () {
            return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, onClick: _this.handleClick, style: styles.button, testId: EmbedCodeLinkTestId, title: Localize_1.Messages.embedCodeLinkTitle() },
                React.createElement("span", { style: styles.copyEmbedCodeSpan },
                    React.createElement(CopyEmbedCodeIcon_1.CopyEmbedCodeIcon, { style: styles.icon, "aria-hidden": true }),
                    Localize_1.Messages.embedCodeLinkTitle())));
        };
        return _this;
    }
    EmbedCodeLink.prototype.render = function () {
        return this.renderEmbedCode();
    };
    return EmbedCodeLink;
}(React.PureComponent));
exports.EmbedCodeLink = EmbedCodeLink;
//# sourceMappingURL=EmbedCodeLink.js.map